import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useFidelityMaximizerEligibility = () => {
  const { country, isSelectraAdmin } = useSelector(selectAuthData)
  const fidelityMaximizerEnabled = modulesConfig[country]?.customer?.fidelityMaximizer ?? false

  return fidelityMaximizerEnabled && isSelectraAdmin === true
}

export default useFidelityMaximizerEligibility
